<div class="index-settings" data-automation-id="index-settings-container">
    <div class="header-bar" data-automation-id="index-settings-header" [hidden]="isDataSetConfigModal">
        <button type="button" data-automation-id="index-settings-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="isSaveDisabled()" *ngIf="hasPermissions">Save</button>
        <button type="button" data-automation-id="index-settings-discard-changes-button" class="secondary-button"
            (click)="discardChanges()" [disabled]="isDiscardDisabled()" *ngIf="hasPermissions">Discard
            Changes</button>
        <span class="parsing-version" *ngIf="!isDataSetConfigModal"
            data-automation-id="index-settings-parsing-library-version-label">Parsing Library Version:
            {{viewModel.model.externalParsingLibraryDisplay}}</span>
        <button type="button" class="help-button" data-automation-id="index-settings-help-button" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>

    <form class="content" #contentForm="ngForm" [resBusySpinner]="isBusy" [message]="isBusyMessage"
        data-automation-id="index-settings-content">
        <div class="left-settings-panel">
            <div class="settings-panel-header">
                <span>Parsing Settings</span>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox name="includeCurrency" automationId="index-settings-parse-currency"
                        [(ngModel)]="viewModel.model.includeCurrency" content="Parse Currency"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <res-custom-checkbox name="includeNumericQuantities"
                        automationId="index-settings-parse-numeric-quantities"
                        [(ngModel)]="viewModel.model.includeNumericQuantities" content="Parse Numeric Quantities"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <res-custom-checkbox name="includeNumericTerms" automationId="index-settings-parse-numeric-terms"
                        [(ngModel)]="viewModel.model.includeNumericTerms" content="Parse Numeric Terms"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <res-custom-checkbox name="accentSensitiveIndex"
                        automationId="index-settings-use-accent-sensitive-index"
                        [(ngModel)]="viewModel.model.accentSensitive" content="Use Accent Sensitive Index"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <res-custom-checkbox name="languageDetectionProcessing"
                        automationId="index-settings-detect-languages"
                        [(ngModel)]="viewModel.model.languageDetectionProcessing" content="Detect Languages"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <res-custom-checkbox *ngIf="viewModel.model.virusDetection !== null" name="virusDetection"
                        automationId="index-settings-detect-viruses" [(ngModel)]="viewModel.model.virusDetection"
                        content="Detect Viruses" [isDisabled]="isDataSetConfigModal || !hasPermissions"
                        (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <div class="no-info-available" *ngIf="viewModel.model.virusDetection === null">
                        <i class="fa fa-question" title="No information available"></i>
                        <span>Detect Viruses</span>
                    </div>
                    <div class="line-spacer"></div>
                    <div class="embedded-images-px" [ngStyle]="{'pointer-events': isDataSetConfigModal ? 'none' : '' }"
                        id="embeddedImagesContainer">
                        <res-custom-checkbox name="extractEmbeddedImages"
                            automationId="index-settings-extract-embedded-images"
                            [(ngModel)]="viewModel.model.extractEmbeddedImages" content="{{extractEmbeddedImagesLabel}}"
                            [isDisabled]="isDataSetConfigModal || !hasPermissions"
                            (ngModelChange)="onChange(); setEmbeddedImagesPx();">
                        </res-custom-checkbox>
                        <div *ngIf="viewModel.model.externalParsingLibraryDisplay === 'V2'" class="input-checkbox">
                            <input type="text" [(ngModel)]="viewModel.model.embeddedImageWidth" class="input-area"
                                (blur)="inputEmbeddedImagesWidthChanged()" (mouseover)="changeHoverStyle(true)"
                                (mouseout)="changeHoverStyle(false)" (keypress)="restrictNumeric($event)"
                                (keyup)="preventFirstZero($event)"
                                (ngModelChange)="hidePopovers(); validateEmbeddedSizeInputOnPaste('embeddedImageWidth'); onChange();"
                                name="embeddedImagesWidth"
                                (change)="extractEmbeddedImageWidthPopover.hide(); validateEmbeddedSizeInputOnPaste('embeddedImageWidth');"
                                automationId="index-settings-extract-embedded-images-width-input"
                                [disabled]="!viewModel.model.extractEmbeddedImages || isDataSetConfigModal || !hasPermissions"
                                triggers="" maxlength="5" containerClass="info" container="body"
                                [popover]="errorPopoverTemplateWidth" #extractEmbeddedImageWidthPopover="bs-popover"
                                placement="top" />
                            <ng-template #errorPopoverTemplateWidth>
                                <span
                                    automationId="extract-embedded-images-width-input-info-label">{{noBlankInfoText}}</span>
                                <i class="fa fa-close" (click)="extractEmbeddedImageWidthPopover.hide()"></i>
                            </ng-template>
                            <label class="label-input" [attr.for]="checkboxId" (click)="onEmbeddedImageChange()"
                                [ngClass]="[isDataSetConfigModal || !hasPermissions ? 'disabled-fields' : '']"
                                automationId="index-settings-extract-embedded-images-taller-then-label"
                                (click)="onChange(); setEmbeddedImagesPx();">
                                px OR taller than
                            </label>
                            <input type="text" [(ngModel)]="viewModel.model.embeddedImageHeight" class="input-area"
                                (blur)="inputEmbeddedImagesHeightChanged()" (keypress)="restrictNumeric($event)"
                                (mouseover)="changeHoverStyle(true)" (mouseout)="changeHoverStyle(false)"
                                (ngModelChange)="hidePopovers(); validateEmbeddedSizeInputOnPaste('embeddedImageHeight'); onChange();"
                                (change)="extractEmbeddedImageHeightPopover.hide(); validateEmbeddedSizeInputOnPaste('embeddedImageHeight');"
                                automationId="index-settings-extract-embedded-images-height-input"
                                (keyup)="preventFirstZero($event)"
                                [disabled]="!viewModel.model.extractEmbeddedImages || isDataSetConfigModal || !hasPermissions"
                                triggers="" maxlength="5" containerClass="info" container="body"
                                name="embeddedImagesHeight" [popover]="errorPopoverTemplateHeight"
                                #extractEmbeddedImageHeightPopover="bs-popover" placement="top" />
                            <ng-template #errorPopoverTemplateHeight>
                                <span
                                    automationId="extract-embedded-images-height-input-info-label">{{noBlankInfoText}}</span>
                                <i class="fa fa-close" (click)="extractEmbeddedImageHeightPopover.hide()"></i>
                            </ng-template>
                            <label class="px-label" [attr.for]="checkboxId" (click)="onEmbeddedImageChange()"
                                automationId="index-settings-extract-embedded-images-px-label"
                                [ngClass]="[isDataSetConfigModal || !hasPermissions ? 'disabled-fields' : '']"
                                (click)="onChange(); setEmbeddedImagesPx();">px</label>
                        </div>
                    </div>
                    <res-custom-checkbox name="ignoreTransportHeaders"
                        automationId="index-settings-ignore-transport-layers"
                        [(ngModel)]="viewModel.model.ignoreTransportHeaders"
                        content="Prioritize MAPI Fields over Transport Header Metadata"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <res-custom-checkbox name="pageBreaks" automationId="index-settings-include-page-breaks"
                        [(ngModel)]="viewModel.model.includePageBreaks" content="Include Page Breaks"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <res-custom-checkbox name="splitChats" automationId="index-settings-split-bloomberg-chat"
                        [(ngModel)]="viewModel.model.splitChats" content="Split Bloomberg Chat"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <res-custom-checkbox *ngIf="viewModel.model.splitJournaledEmails !== null"
                        name="splitJournaledEmails" automationId="index-settings-split-journaled-emails"
                        [(ngModel)]="viewModel.model.splitJournaledEmails" content="Split Journaled Emails"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <div class="no-info-available" *ngIf="viewModel.model.splitJournaledEmails === null">
                        <i class="fa fa-question" title="No information available"></i>
                        <span>Split Journaled Emails</span>
                    </div>
                    <res-custom-checkbox *ngIf="viewModel.model.splitIndividualRSMFMessage !== null"
                        name="splitIndividualRSMFMessage" automationId="index-settings-split-individual-rsmf-messages"
                        [(ngModel)]="viewModel.model.splitIndividualRSMFMessage"
                        content="Split Individual RSMF Messages" [isDisabled]="isDataSetConfigModal || !hasPermissions"
                        (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <div class="input-label-row">
                        <label [class.disabled]="isDataSetConfigModal || !hasPermissions">Document Processing
                            Timeout:</label>
                        <input #msgDocumentProcessingTimeout type="text" (keypress)="restrictNumeric($event)"
                            (blur)="parseNumeric(3, 180, 'Document')"
                            [(ngModel)]="viewModel.model.documentProcessingTimeout" maxlength="4" title="Enter: 3 - 180"
                            (ngModelChange)="onChange()"
                            automationId="index-settings-message-document-processing-timeout-input"
                            class="error-popover" containerClass="info" container="body"
                            [popover]="errorDocumentPopoverTemplate" triggers="" name="messageDocumentTimeout"
                            #rangeInfoDocumentPopover="bs-popover" placement="top"
                            [disabled]="isDataSetConfigModal || !hasPermissions" />
                        <ng-template #errorDocumentPopoverTemplate>
                            <span
                                automationId="index-settings-document-processing-timeout-info-label">{{rangeInfoText}}</span>
                            <i class="fa fa-close" (click)="rangeInfoDocumentPopover.hide()"></i>
                        </ng-template>
                        <label [class.disabled]="isDataSetConfigModal || !hasPermissions">minutes</label>
                    </div>
                    <div class="input-label-row" [ngStyle]="{'margin-top' : '10px'}">
                        <label [class.disabled]="isDataSetConfigModal || !hasPermissions">Archive Processing
                            Timeout:</label>
                        <input #msgArchiveProcessingTimeout type="text" (keypress)="restrictNumeric($event)"
                            (blur)="parseNumeric(10, 1200, 'Archive')"
                            [(ngModel)]="viewModel.model.archivalProcessingTimeout" maxlength="4"
                            title="Enter: 10 - 1200" (ngModelChange)="onChange()"
                            automationId="index-settings-message-archive-processing-timeout-input" class="error-popover"
                            containerClass="info" container="body" [popover]="errorArchivePopoverTemplate" triggers=""
                            name="messageArchiveTimeout" #rangeInfoArchivePopover="bs-popover" placement="top"
                            [disabled]="isDataSetConfigModal || !hasPermissions" [ngStyle]="{'margin-left' : '26px'}" />
                        <ng-template #errorArchivePopoverTemplate>
                            <span
                                automationId="index-settings-archive-processing-timeout-info-label">{{rangeInfoText}}</span>
                            <i class="fa fa-close" (click)="rangeInfoArchivePopover.hide()"></i>
                        </ng-template>
                        <label [class.disabled]="isDataSetConfigModal || !hasPermissions">minutes</label>
                    </div>
                    <div class="line-spacer"></div>
                </div>
            </div>
            <div class="settings-panel-header top-border">Advanced Analytic Operations</div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox name="clusterWithStopWords" automationId="index-settings-include-stop-words"
                        [(ngModel)]="viewModel.model.clusterWithStopWords" content="Include Stop Words"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <div class="line-spacer"></div>
                </div>
            </div>
            <div class="settings-panel-header top-border">Copy to Document Storage</div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox name="copyToDocStorage" automationId="index-settings-auto-copy-to-doc-storage"
                        [(ngModel)]="viewModel.model.copyToDocStorage"
                        content="Enable Automatic Copy to Document Storage"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                    <div class="line-spacer"></div>
                    <res-custom-checkbox name="DOCCLASS_DISKIMAGE" automationId="index-settings-storage-disk-image"
                        [(ngModel)]="docStorageExclusions.DOCCLASS_DISKIMAGE"
                        content="Exclude Document Class: Disk Image"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions"
                        (ngModelChange)="onChange(DocStorageExclusions.DOCCLASS_DISKIMAGE)"></res-custom-checkbox>
                    <res-custom-checkbox name="DOCCLASS_ARCHIVE" automationId="index-settings-storage-archive-image"
                        [(ngModel)]="docStorageExclusions.DOCCLASS_ARCHIVE" content="Exclude Document Class: Archive"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions"
                        (ngModelChange)="onChange(DocStorageExclusions.DOCCLASS_ARCHIVE)"></res-custom-checkbox>
                    <res-custom-checkbox name="DOCCLASS_MAIL_CONTAINER"
                        automationId="index-settings-message-archive-image"
                        [(ngModel)]="docStorageExclusions.DOCCLASS_MAIL_CONTAINER"
                        content="Exclude Document Class: Message Archive"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions"
                        (ngModelChange)="onChange(DocStorageExclusions.DOCCLASS_MAIL_CONTAINER)"></res-custom-checkbox>
                    <res-custom-checkbox name="NIST_EDOC" automationId="index-settings-nist-edoc-image"
                        [(ngModel)]="docStorageExclusions.NIST_EDOC" content="Exclude NIST EDoc"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions"
                        (ngModelChange)="onChange(DocStorageExclusions.NIST_EDOC)">
                    </res-custom-checkbox>
                </div>
            </div>
            <div class="line-spacer"></div>

            <div class="settings-panel-header top-border">Other Settings</div>
            <div class="modal-row">
                <div class="modal-row-column-auto column-left-text">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">Custodian Directory: </label>
                </div>
                <div class="modal-row-column-auto">
                    <input type="text" name="custodianDirectoryLevel" class="page-timeout-width"
                        [(ngModel)]="viewModel.model.custodianDirectoryLocation"
                        [value]="viewModel.model.custodianDirectoryLocation"
                        data-automation-id="index-settings-other-custodian-directory-level-input"
                        [disabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                </div>
                <div class="modal-row-column-auto">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">level(s) down from Data
                        Area</label>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto column-left-text">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">Media Directory: </label>
                </div>
                <div class="modal-row-column-auto">
                    <input type="text" name="mediaDirectoryLevel" class="page-timeout-width"
                        [(ngModel)]="viewModel.model.mediaDirectoryLocation"
                        [value]="viewModel.model.mediaDirectoryLocation"
                        data-automation-id="index-settings-other-media-directory-level-input"
                        [disabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                </div>
                <div class="modal-row-column-auto">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">level(s) down from Data
                        Area</label>
                </div>
            </div>
            <div class="modal-row" [hidden]="!isProjectSettings">
                <div class="modal-row-column-auto column-left-text">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">Matter Name: </label>
                </div>
                <div class="modal-row-column-auto">
                    <input type="text" name="matterName" [(ngModel)]="viewModel.model.matterName"
                        [value]="viewModel.model.matterName" data-automation-id="index-settings-other-matter-name-input"
                        class="matter-input-width" [disabled]="isDataSetConfigModal || !hasPermissions"
                        (ngModelChange)="onChange()">
                </div>
            </div>
            <div class="modal-row" [hidden]="!isProjectSettings">
                <div class="modal-row-column-auto column-left-text">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">Matter Number: </label>
                </div>
                <div class="modal-row-column-auto">
                    <input type="text" name="matterNumber" [(ngModel)]="viewModel.model.matterNumber"
                        [value]="viewModel.model.matterNumber"
                        data-automation-id="index-settings-other-matter-number-input" class="matter-input-width"
                        [disabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                </div>
            </div>
            <div class="line-spacer"></div>

            <div class="settings-panel-header top-border" [hidden]="isDataSetConfigModal">Excluded File Extensions for
                Extraction
            </div>
            <div class="key-value-list-container" [hidden]="isDataSetConfigModal"
                [attr.data-automation-id]="excludedFileExtensionsForExtractionAutomationId + 'container'">
                <res-key-value-list #excludedFileExtensionsForExtractionKeyValue
                    [placeholderField1]='"Enter one file extension without periods per line (i.e. jar, zip, etc.) ..."'
                    [isDisabled]="!hasPermissions" [checkDuplicate]="true" [rows]="viewModel.model.extractionExclusions"
                    [queryColumnHidden]="true" [cdkScrollMinBufferPx]="1000" [cdkScrollMaxBufferPx]="3000"
                    [attr.data-automation-id]="excludedFileExtensionsForExtractionAutomationId + 'key-value-list'"
                    [excludeTrashBtnFromTabIndex]="true"
                    [automationId]="excludedFileExtensionsForExtractionAutomationId" [maxNameLength]="100">
                </res-key-value-list>
            </div>
            <div class="line-spacer" [hidden]="isDataSetConfigModal"></div>
        </div>
        <div class="right-settings-panel">
            <div class="settings-panel-header">Automatic OCR Settings</div>
            <div class="modal-row" *ngIf="!isSelectedLanguageUnknown">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox name="ocrProcessing" automationId="index-settings-automatic-ocr-processing"
                        [(ngModel)]="viewModel.model.ocrProcessing" content="Enable Automatic OCR Processing"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                </div>
                <div class="line-spacer"></div>
            </div>
            <div class="modal-row" *ngIf="!isSelectedLanguageUnknown">
                <div class="modal-row-column-auto column-left-text">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">Language Selection: </label>
                </div>
                <div class="modal-row-column-auto">
                    <select name="selectedLanguage" automationId="index-settings-ocr-language"
                        [(ngModel)]="selectedLanguage" (ngModelChange)="onLanguageChange()"
                        class="select-language-input" [disabled]="isDataSetConfigModal || !hasPermissions">
                        <option *ngFor="let language of languages | values" [value]="language">{{language}}</option>
                    </select>
                </div>
            </div>
            <div class="modal-row" *ngIf="!isSelectedLanguageUnknown">
                <div class="modal-row-column-auto column-left-text">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">Accuracy:</label>
                </div>
                <div class="modal-row-column-auto accuracy-radio-spacer">
                    <div class="section">
                        <res-custom-radio-button automationId="index-settings-accuracy-medium"
                            [(ngModel)]="viewModel.model.ocrAccuracyHigh" content="Medium" name="accuracyLevel"
                            [value]="false" [isDisabled]="isDataSetConfigModal || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-radio-button>
                        <res-custom-radio-button automationId="index-settings-accuracy-high"
                            [(ngModel)]="viewModel.model.ocrAccuracyHigh" content="High" name="accuracyLevel"
                            [value]="true" [isDisabled]="isDataSetConfigModal || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-radio-button>
                    </div>

                </div>
            </div>
            <div class="modal-row" *ngIf="!isSelectedLanguageUnknown">
                <div class="modal-row-column-auto column-left-text">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">Page Timeout: </label>
                </div>
                <div class="modal-row-column-auto">
                    <input type="number" min="1" pattern="[0-9]*" (input)="updateAutoOCRPageTimeout($event)"
                        name="ocrPageTimeout" class="page-timeout-width" [(ngModel)]="viewModel.model.ocrPageTimeout"
                        [value]="viewModel.model.ocrPageTimeout" (blur)="updateAutoOCRPageTimeout($event)"
                        data-automation-id="index-settings-ocr-page-timeout-input"
                        [disabled]="isDataSetConfigModal || !hasPermissions"
                        [ngStyle]="{'background-color': isDataSetConfigModal ? '#f2f2f2' : '', 'color':isDataSetConfigModal? '#aaaaaa': '', 'border': isDataSetConfigModal ? '1px solid #cccccc' : ''}">
                </div>
                <div class="modal-row-column-auto">
                    <label [class.disabled]="isDataSetConfigModal || !hasPermissions">seconds</label>
                </div>
                <div class="modal-row-column-auto">
                    <span class="error-popover" data-automation-id="index-settings-page-timeout-error-label'"
                        containerClass="error" container="body" [popover]="errorPopTmpl" triggers=""
                        #errorPop="bs-popover" placement="right"></span>
                    <ng-template #errorPopTmpl>
                        <span data-automation-id="">Only non-zero values !</span>
                        <i class="fa fa-close" (click)="errorPop.hide()"></i>
                    </ng-template>
                </div>
            </div>
            <div class="modal-row no-auto-info-available" *ngIf="isSelectedLanguageUnknown">
                No information available
            </div>
            <div class="line-spacer" [hidden]="isDataSetConfigModal"></div>

            <div class="line-spacer" [hidden]="!isDataSetConfigModal"></div>

            <div class="settings-panel-header top-border" [hidden]="isDataSetConfigModal">OCR Queries</div>
            <div class="key-value-list-container"
                [attr.data-automation-id]="ocrCandidatesNamedQueriesAutomationId + 'container'"
                [hidden]="isDataSetConfigModal">
                <res-key-value-list #queriesKeyValue [placeholderField1]='"Search Name ..."'
                    [placeholderField2]='"Search Query ..."' [rows]="viewModel.model.ocrCandidatesNamedQueries"
                    [attr.data-automation-id]="ocrCandidatesNamedQueriesAutomationId + 'key-value-list'"
                    [excludeTrashBtnFromTabIndex]="true" [automationId]="ocrCandidatesNamedQueriesAutomationId"
                    [isDisabled]="isDataSetConfigModal || !hasPermissions" [validateName]="true" [maxNameLength]="100"
                    [maxQueryLength]="1024" [isQueryValidationContext]="true"
                    [settingsType]="settingsType"></res-key-value-list>
            </div>
            <div class="line-spacer" [hidden]="isDataSetConfigModal"></div>

            <div class="settings-panel-header top-border" [hidden]="isDataSetConfigModal">Custom Warnings and Errors
            </div>
            <div class="key-value-list-container" [hidden]="isDataSetConfigModal"
                [style.--kvl-height]="keyValueListHeightPx(viewModel.model.customWarningsAndErrorNamedQueries)"
                [attr.data-automation-id]="customWarningsAndErrorAutomationId + 'container'">
                <res-key-value-list #customWarningErrorKeyKalue [placeholderField1]='"Search Name ..."'
                    [isDisabled]="!hasPermissions" [placeholderField2]='"Search Query ..."'
                    [rows]="viewModel.model.customWarningsAndErrorNamedQueries"
                    [attr.data-automation-id]="customWarningsAndErrorAutomationId + 'key-value-list'"
                    [excludeTrashBtnFromTabIndex]="true" [automationId]="customWarningsAndErrorAutomationId"
                    [validateName]="true" [maxNameLength]="100" [maxQueryLength]="1024"
                    [isQueryValidationContext]="true" [settingsType]="settingsType">
                </res-key-value-list>
            </div>
            <div class="line-spacer" [hidden]="isDataSetConfigModal"></div>

            <div class="settings-panel-header top-border">
                Custom Email Header Field Mapping
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox name="includeEmailHeaders" automationId="index-settings-include-email-headers"
                        [(ngModel)]="viewModel.model.includeEmailHeaders" content="Include Entire Email Header"
                        [isDisabled]="isDataSetConfigModal || !hasPermissions"
                        (ngModelChange)="onChange();onIncludeEmailHeadersChanged()">
                    </res-custom-checkbox>
                    <res-custom-checkbox name="parseCustomEmailHeaders"
                        automationId="index-settings-parse-custom-email-header" [marginLeft]="27"
                        [(ngModel)]="viewModel.model.extractCustomEmailHeaders" content="Parse Custom Email Header"
                        [isDisabled]="!viewModel.model.includeEmailHeaders || isDataSetConfigModal || !hasPermissions"
                        (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                </div>
            </div>
            <div class="modal-row">
                <div class="header-line-container"
                    [hidden]="viewModel.model?.emailHeaderMappingsAsArray === null || viewModel.model?.emailHeaderMappingsAsArray?.length === 0">
                    <div class="settings-panel-header email-header-field">Email Header Field</div>
                    <div class="settings-panel-header dr-custom-field"
                        [ngClass]="[isDataSetConfigModal ? 'custom-field-view-config' : '']">DR Custom Field</div>
                </div>
            </div>
            <div class="email-header-mapping-key-value-container"
                [attr.data-automation-id]="customEmailHeaderFieldMappingAutomationId + 'container'">
                <res-key-value-list #emailHeaderMappings
                    [placeholderField1]='"Email Header Field. Enter individually or paste multiple ..."'
                    [isDisabled]="isDataSetConfigModal || !hasPermissions"
                    [placeholderField2]='"Corresponding DR Custom Field name will be generated here"'
                    [rows]="viewModel.model.emailHeaderMappingsAsArray" [cdkScrollMaxBufferPx]="5000"
                    [attr.data-automation-id]="customEmailHeaderFieldMappingAutomationId + 'key-value-list'"
                    [isQueryColumnAutoPopulated]="true" [excludeTrashBtnFromTabIndex]="true"
                    [displayGeneralMessage]="true" [automationId]="customEmailHeaderFieldMappingAutomationId"
                    [checkDuplicate]="true" [maxNameLength]="248" [maxQueryLength]="255"
                    [queriesChanged]="queriesChanged.bind(this)">
                </res-key-value-list>
            </div>
            <div class="line-spacer"></div>

            <div class="settings-panel-header top-border"
                [hidden]="!isDataSetConfigModal || viewModel.model?.extractionExclusions === null || viewModel.model?.extractionExclusions?.length === 0">
                Excluded File Extensions for Extraction
            </div>
            <div class="key-value-list-container-exclusion view-config"
                [hidden]="!isDataSetConfigModal || !viewModel.model.extractionExclusions"
                [ngClass]="[isVerticalScrollbarVisible() ? 'scroll-right-padding' : '']"
                [attr.data-automation-id]="excludedFileExtensionsForExtractionAutomationId + 'container'">
                <res-key-value-list #excludedFileExtensionsForExtractionKeyValueViewConfig
                    [placeholderField1]='"Enter one file extension without periods per line (i.e. jar, zip, etc.) ..."'
                    [isDisabled]="!hasPermissions" [checkDuplicate]="true"
                    id="excludedFileExtensionsForExtractionKeyValueViewConfigId"
                    [rows]="viewModel.model.extractionExclusions" [queryColumnHidden]="true"
                    [cdkScrollMinBufferPx]="1000" [cdkScrollMaxBufferPx]="3000"
                    [attr.data-automation-id]="excludedFileExtensionsForExtractionAutomationId + 'key-value-list'"
                    [excludeTrashBtnFromTabIndex]="true"
                    [automationId]="excludedFileExtensionsForExtractionAutomationId" [maxNameLength]="100">
                </res-key-value-list>
            </div>
            <div class="line-spacer" [hidden]="!isDataSetConfigModal"></div>
        </div>
    </form>
</div>